<script>
import { VTextarea } from 'vuetify/lib'
import inputMixin from './mixin_input'
export default {
	extends: VTextarea,
	mixins: [inputMixin],
}
</script>
